import CopyButton from "./CopyButton";

import type { AlertProps } from "@mui/material/Alert";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export interface ErrorMessageProps extends Omit<
  AlertProps,
  "severity" | "children"
> {
  error: string | Error | null | undefined | unknown;
  digest?: string; // Optional digest for error tracking, can be used to correlate with backend logs
}

/**
 * Consistent error message component that handles both string and Error objects.
 * Automatically extracts error messages from Error objects (including HTTP errors from fetchApi).
 */
export default function ErrorMessage({
  error,
  digest,
  sx,
  ...otherProps
}: ErrorMessageProps) {
  if (!error) return null;

  let errorMessage: string;

  if (typeof error === "string") {
    errorMessage = error;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else {
    errorMessage = "A apărut o eroare neașteptată.";
  }

  return (
    <Alert
      severity="error"
      sx={{
        mb: 3,
        position: "relative",
        paddingRight: "46px",
        "&:hover .error-copy-button": {
          opacity: 1,
        },
        ...sx,
      }}
      {...otherProps}
    >
      <span>{errorMessage}</span>
      {digest && (
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontSize: "0.7rem"
            }}>
            Digest: {digest}
          </Typography>
        </Box>
      )}
      <Box
        className="error-copy-button"
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          opacity: 0,
          transition: "opacity 200ms",
        }}
      >
        <CopyButton
          value={errorMessage + (digest ? `\nDigest: ${digest}` : "")}
        />
      </Box>
    </Alert>
  );
}
